import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlockSortDescending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBlockSortDescending"><Path d="M11 3H3V11H11V3Z" fill="currentColor"/><Path d="M22.7803 13.5205L21.7197 12.46L18.75 15.4297V6H17.25V15.4297L14.2803 12.46L13.2197 13.5205L18 18.3008L22.7803 13.5205Z" fill="currentColor"/><Path d="M11 13H3V21H11V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlockSortDescending;
